import { AlertCircle } from "lucide-react";

import { useUser } from "@/hooks/useUser";
import { getEstDaysRemaining } from "@/utils/getEstDaysRemaining";

export function FirstDraftExpiredBanner() {
  const { currentProject, data } = useUser();

  const cancelled = currentProject?.subscriptionCancelledAt ?? null;
  const daysRemaining = cancelled ? getEstDaysRemaining(cancelled) : 0;

  if (
    !currentProject?.isFirstDraft ||
    !cancelled ||
    daysRemaining > 0 ||
    currentProject?.subscriptionStatus.subscriptionActive
  ) {
    return null;
  }

  const firstName = data?.user?.name?.split(" ")[0] ?? "";

  return (
    <div className="px-6 pt-4">
      <div
        className="flex items-start gap-4 rounded-xl border border-border-secondary bg-bg-primary p-4"
        style={{ boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)" }}
      >
        <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-bg-warning-secondary">
          <AlertCircle className="size-5 text-featured-icon-light-fg-warning" />
        </div>
        <div className="flex flex-col gap-3">
          <div className="flex flex-col gap-1">
            <span className="text-sm font-semibold text-text-primary">
              Hi {firstName}, your First Draft trial has expired.
            </span>
            <span className="text-sm text-text-primary">
              All requests are paused, but you can upgrade anytime and continue
              right where you left off.
            </span>
          </div>
          <a
            href="https://nlc.com/manage-my-account"
            rel="noreferrer"
            target="_blank"
          >
            <span className="text-sm text-text-secondary">
              Ready to jump back in?{" "}
            </span>
            <span className="text-sm font-semibold underline text-text-brand-primary">
              Upgrade your plan
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}
